import OpenRoutes from './OpenRoutes'
import PrivateRoutes from './PrivateRoutes'

export const openRoutes = OpenRoutes
export const privateRoutes = PrivateRoutes